import React from 'react';

export const componentWithSuspense =
	(Component: React.ComponentType, fallback?: React.ReactNode) => (): React.JSX.Element => {
		return (
			<React.Suspense fallback={fallback}>
				<Component />
			</React.Suspense>
		);
	};
